/* The form-level error banner, from the approved auth mockup's `.banner` rule. */

.banner {
  display: flex;
  align-items: flex-start;
  gap: var(--space-2);
  margin-bottom: var(--space-4);
  padding: var(--space-3);
  border: var(--border-hairline) solid var(--danger-border);
  border-radius: var(--radius-sm);
  background: var(--danger-soft);
  font-family: var(--font-body);
  font-size: var(--fs-note);
  font-weight: var(--fw-semibold);
  line-height: var(--lh-normal);

  /* `--danger-text-strong`, not `--danger-ink`: the message sits on the soft danger tint, where the
   * lighter ink measures 3.32:1 and fails AA for 12.5px text. Measured, not assumed. */
  color: var(--danger-text-strong);
}

.icon {
  flex: none;
  width: var(--icon-xs);
  height: var(--icon-xs);

  /* The glyph is aligned to the first line of text, not to the box, so a wrapping message does not
   * float the icon into the middle of the block. */
  margin-top: var(--space-1);
}

/* A backend validation map can carry several messages for one field; they arrive newline-joined and
 * must not collapse into one run-on sentence. */
.text {
  white-space: pre-line;
}
